import styled from "styled-components";

export const StyledMainCard = styled.div<{ fullWidth?: boolean }>`
  cursor: pointer;
  display: flex;
  width: ${({ fullWidth }) => (fullWidth ? "100%" : "215px")};
  height: 274px;
  flex-shrink: 0;
  border-radius: 20px;
  position: relative;
  background-color: ${({ theme }) => theme.colors.card};
  img {
    border-radius: inherit;
    object-fit: cover;
    border-radius: inherit;
    width: ${({ fullWidth }) => (fullWidth ? "100%" : "215px")};
    height: auto;
    object-position: center;
  }
`;

export const StyledSupportCard = styled.div<{ fullWidth?: boolean }>`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 4px;
  width: ${({ fullWidth }) => (fullWidth ? "100%" : "180px")};
  height: ${({ fullWidth }) => (fullWidth ? "274px" : "186px")};
  flex-shrink: 0;
  border-radius: 20px;
  position: relative;
  background-color: ${({ theme }) => theme.colors.card};
  font-family: ${(props) => props.theme.typography.textsFont};
  padding: 4px 2px;
  box-sizing: border-box;
  h4 {
    margin: 0;
    color: ${({ theme }) => theme.colors.text};
    margin-top: 12px;

    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    width: calc(100% - 20px);
    text-align: left;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  p {
    margin: 0;
    margin-top: 0px;
    width: calc(100% - 20px);
    text-align: left;
    color: ${({ theme }) => theme.colors.text};
    font-family: ${(props) => props.theme.typography.textsFont};
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  img {
    border-radius: 14px;
    filter: grayscale(1);
    width: ${({ fullWidth }) => (fullWidth ? "100%" : "172px")};
    height: ${({ fullWidth }) => (fullWidth ? "214px" : "126px")};
    object-fit: cover;
    object-position: center;
  }
`;
export const NameTag = styled.div<{ fullWidth?: boolean }>`
  position: absolute;
  display: flex;
  padding: 4px 12px;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  background-color: #00000030;
  color: ${({ theme }) => theme.colors.buttonFont};
  font-family: ${(props) => props.theme.typography.textsFont};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-radius: 59px;

  bottom: 44px;
  left: 12px;
  right: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const NightCount = styled.div<{ fullWidth?: boolean }>`
  position: absolute;
  border-radius: 59px;
  background: rgba(39, 39, 39, 0.83);
  display: flex;
  padding: 4px 6px;
  justify-content: flex-start;
  align-items: center;
  gap: 14px;
  background-color: ${({ theme }) => theme.colors.backgroundOpacity};
  color: ${({ theme }) => theme.colors.buttonFont};
  font-family: ${(props) => props.theme.typography.textsFont};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-radius: 59px;
  bottom: 14px;
  left: 12px;
  width: fit-content;
  span {
    display: flex;
    align-items: center;
    gap: 6px;
    p {
      color: ${({ theme }) => theme.colors.buttonFont};
      margin: 0;
      padding: 0;
      font-size: 12px;
    }
  }
`;

export const StatusTag = styled.div`
  position: absolute;
  border-radius: 59px;
  background: rgba(39, 39, 39, 0.83);
  display: flex;
  padding: 6px 10px;
  justify-content: flex-start;
  align-items: center;
  gap: 14px;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.buttonFont};
  font-family: ${(props) => props.theme.typography.textsFont};
  font-size: 12px;
  top: 14px;
  right: 12px;
`;
